import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './life-area-form-error.style';

export type LifeAreaFormErrorProps = {
  onRetry: () => void;
  onCancel: () => void;
  isEdit?: boolean;
};

export const LifeAreaFormError: React.FC<LifeAreaFormErrorProps> = ({
  onRetry,
  onCancel,
  isEdit,
}) => {
  const { t } = useTranslation();
  return (
    <Styled.Container>
      <Styled.Body>
        <Typography variant="h2">
          {t(
            isEdit
              ? 'forms.life-area.retry.edit.title'
              : 'forms.life-area.retry.create.title',
          )}
        </Typography>
        <Typography variant="overline">
          {t(
            isEdit
              ? 'forms.life-area.retry.edit.description'
              : 'forms.life-area.retry.create.description',
          )}
        </Typography>
      </Styled.Body>
      <Styled.Interactions>
        <Button
          variant={Variants.Outlined}
          size={Sizes.Medium}
          onClick={onCancel}
          type="button"
        >
          {t('forms.life-area.retry.cancel.label')}
        </Button>
        <Button size={Sizes.Medium} type="submit" onClick={onRetry}>
          {t('forms.life-area.retry.save.label')}
        </Button>
      </Styled.Interactions>
    </Styled.Container>
  );
};
